<script setup lang="ts">
import { useTabsStore } from './store';
import type { PropsMenuTitle } from './types';
import TabsViewMenuDelimeter from './menuDelimeter.vue';
import { TopPopupListItem } from '../../popup/popup';

defineProps<PropsMenuTitle>();

const store = useTabsStore();
</script>

<template>
	<TopPopupListItem
		v-if="store.showMenuInPopup"
		type="title"
	>
		<slot></slot>
	</TopPopupListItem>

	<TabsViewMenuDelimeter v-else-if="store.isShort"/>

	<div
		v-else
		:class="{
			'top-tabsView_menuTitle': true,
			'top-tabsView_menuTitle-subtitle': isSubtitle,
		}"
	>
		<slot></slot>
	</div>
</template>

<style>
.top-tabsView_menuTitle {
	padding: var(--top-padding-4) var(--top-padding-2) var(--top-padding-1);
	font-weight: 600;
	color: var(--color-text-1);
}

.top-tabsView_menuTitle-subtitle {
	padding-top: var(--top-padding-1);
	font-size: 12px;
	font-weight: 400;
	color: var(--color-text-2);
}
</style>
